import React from 'react';
import { Router, Route, IndexRoute } from 'react-router';
import ga from 'react-ga';
import MainApp from 'app';


const logPageView = () => {
    ga.pageview(window.location.pathname + window.location.search);
};

export default ({ history }) => (
  <Router history={history} onUpdate={logPageView}>
    <Route path="/" component={MainApp}>
    	<IndexRoute getComponent={(location, cb) => {
            require.ensure([], (require) => {
                cb(null, require('pages/home').default)
            });
        }} />
        <Route path="me" getComponent={(location, cb) => {
            require.ensure([], (require) => {
                cb(null, require('pages/home').default)
            });
        }} />
    	<Route path="upload" getComponent={(location, cb) => {
            require.ensure([], (require) => {
                cb(null, require('pages/upload').default)
            });
        }} />
        <Route path="search" getComponent={(location, cb) => {
            require.ensure([], (require) => {
                cb(null, require('pages/search').default)
            });
        }} />
        <Route path="image/:image" getComponent={(location, cb) => {
            require.ensure([], (require) => {
                cb(null, require('pages/image').default)
            });
        }} />
        <Route path="image/:image/crop" getComponent={(location, cb) => {
            require.ensure([], (require) => {
                cb(null, require('pages/crop').default)
            });
        }} />
        <Route path="sizes" getComponent={(location, cb) => {
            require.ensure([], (require) => {
                cb(null, require('pages/groups').default)
            });
        }} />
    </Route>
  </Router>
);



/** WEBPACK FOOTER **
 ** ./routes/index.js
 **/